import { Checkbox, Radio, Select } from "antd";
import _ from "lodash";
import React, { useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { toast } from "react-toastify";
import styled from "styled-components";

import { ReactComponent as ICON_TABLE_DELETE } from "@assets/svgs/ICON_TABLE_DELETE.svg";
import { Button } from "@components/Button";
import ErrorValidate from "@components/ErrorValidate";
import { Icon } from "@components/Icon";
import { StyledInput } from "@components/Input";
import { Text } from "@components/Text";
import { COLOR_DARK, COLOR_GREEN, COLOR_WHITE } from "@static/COLORS";
import { fetchAPI } from "@utils/https/fetchAPI";
import { VALIDATE_RULES } from "@validate/index";

const { Group: RadioGroup } = Radio;

const FormContainer = styled.form`
  width: 100%;
  height: 100%;
  display: flex;
  position: relative;
  flex-direction: column;
  gap: 2px;
`;

const Line = styled.div`
  width: 100%;
  height: 1px;
  margin-bottom: 8px;
  background-color: rgba(0, 0, 0, 0.1);
`;

const InnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex-grow: 1;
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  height: 40px;
`;

const GroupInput = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const GroupCheckBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const SelectCampaignContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 16px;
  align-items: center;
  margin-bottom: 16px;
`;

const OPTION_STATUS = [
  { label: "Windows", value: "WINDOWS" },
  { label: "Android", value: "ANDROID" },
];

export const FormCreate = ({
  customerId,
  locationId,
  setDataList = () => undefined,
  setIsModalVisible,
  dataList,
  floors,
  campaignList,
}) => {
  const [selectedCampaigns, setSelectedCampaigns] = useState([
    { campaignId: null },
  ]);
  const [isSingle, setIsSingle] = useState(false);
  const { control, handleSubmit } = useForm({
    defaultValues: {
      type: "WINDOWS",
    },
  });

  const onHandleCreate = async (data) => {
    const name = _.get(data, ["name"]);
    const width = _.get(data, ["width"]);
    const height = _.get(data, ["height"]);
    const type = _.get(data, ["type"]);
    const floor_id = _.get(data, ["floor_id"]);
    const description = _.get(data, ["description"]);
    const player_id = _.get(data, ["player_id"]);

    const reqPath = isSingle
      ? "/api/v1/device-create-single"
      : "/api/v1/device-create";

    const baseReqData = {
      name,
      type,
      category_customer_id: customerId,
      location_id: locationId,
      screen_width: width,
      screen_height: height,
      description,
      player_id,
      floor_id,
    };

    const reqData = { ...baseReqData };

    const resp = await fetchAPI({
      method: "post",
      path: reqPath,
      isAuth: true,
      data: reqData,
    });
    if (_.get(resp, ["status"])) {
      const results = _.chain(resp).get(["result"]).value();
      toast.success("Create Device Success.");
      setIsModalVisible((prev) => ({ ...prev, isOpen: false }));
      const updateData = _.chain(dataList)
        .thru((list) => {
          return [results, ...list];
        })
        .map((item, index) => {
          return { ...item, key: index + 1, index: index + 1 };
        })
        .value();
      setDataList(updateData);
    }
  };

  const onHandleIsSingleChange = (checked) => {
    if (!checked) {
      setSelectedCampaigns([{ campaignId: null }]);
    }
    setIsSingle(checked);
  };

  const onHandleDeleteDevice = ({ index }) => {
    setSelectedCampaigns((prev) => _.filter(prev, (group, i) => i !== index));
  };

  const getAvailableCampaigns = () => {
    const usedCampaigns = _.chain(selectedCampaigns)
      .cloneDeep()
      .map((item, index) => {
        return _.get(item, ["campaignId"]);
      })
      .value();

    const filterCampaigns = _.filter(campaignList, (item, index) => {
      const id = _.get(item, ["value"]);
      return !_.includes(usedCampaigns, id);
    });

    return filterCampaigns;
  };

  const handleCampaignChange = ({ value, index }) => {
    const updatedCampaigns = _.cloneDeep(selectedCampaigns);
    updatedCampaigns[index] = { campaignId: value };
    setSelectedCampaigns(updatedCampaigns);
  };

  return (
    <FormContainer onSubmit={handleSubmit(onHandleCreate)} autoComplete="off">
      <Line />
      <InnerContainer style={{ overflow: "scroll" }}>
        <div>
          <Controller
            name="name"
            control={control}
            rules={_.get(VALIDATE_RULES, ["required"])}
            render={({ field, fieldState: { error } }) => (
              <div>
                <Text
                  color={COLOR_DARK}
                  fontSize="14px"
                  style={{ marginBottom: 4, marginLeft: 4 }}
                >
                  Name
                </Text>
                <StyledInput
                  label="name"
                  {...field}
                  size="large"
                  placeholder="name"
                />
                <ErrorValidate justify="start" error={error} />
              </div>
            )}
          />

          <Controller
            name="width"
            control={control}
            rules={_.get(VALIDATE_RULES, ["required"])}
            render={({ field, fieldState: { error } }) => (
              <div>
                <Text
                  color={COLOR_DARK}
                  fontSize="14px"
                  style={{ marginBottom: 4, marginLeft: 4 }}
                >
                  Width
                </Text>
                <StyledInput
                  label="width"
                  {...field}
                  size="large"
                  placeholder="width"
                />
                <ErrorValidate justify="start" error={error} />
              </div>
            )}
          />

          <Controller
            name="height"
            control={control}
            rules={_.get(VALIDATE_RULES, ["required"])}
            render={({ field, fieldState: { error } }) => (
              <div>
                <Text
                  color={COLOR_DARK}
                  fontSize="14px"
                  style={{ marginBottom: 4, marginLeft: 4 }}
                >
                  Height
                </Text>
                <StyledInput
                  label="height"
                  {...field}
                  size="large"
                  placeholder="height"
                />
                <ErrorValidate justify="start" error={error} />
              </div>
            )}
          />
          <GroupInput>
            <Controller
              name="type"
              control={control}
              rules={_.get(VALIDATE_RULES, ["required"])}
              render={({ field, fieldState: { error } }) => (
                <div>
                  <Text
                    color={COLOR_DARK}
                    fontSize="14px"
                    style={{ marginBottom: 4, marginLeft: 4 }}
                  >
                    Type
                  </Text>
                  <RadioGroup
                    {...field}
                    options={OPTION_STATUS}
                    optionType="button"
                    style={{
                      borderColor: error ? "red" : undefined,
                    }}
                  />
                  <ErrorValidate justify="start" error={error} />
                </div>
              )}
            />
            <GroupCheckBox>
              <Text color={COLOR_DARK} fontSize="14px">
                Single Device
              </Text>
              <Checkbox
                style={{ marginTop: 10 }}
                checked={isSingle}
                onChange={(e) => onHandleIsSingleChange(e.target.checked)}
              />
            </GroupCheckBox>
          </GroupInput>

          <Controller
            name="floor_id"
            control={control}
            render={({ field, fieldState: { error } }) => (
              <div>
                <Text
                  color={COLOR_DARK}
                  fontSize="14px"
                  style={{ marginBottom: 4, marginLeft: 4 }}
                >
                  Floor
                </Text>
                <Select
                  {...field}
                  size="large"
                  showSearch
                  placeholder="Select a floor"
                  optionFilterProp="children"
                  style={{ width: "100%" }}
                  filterOption={(input, option) =>
                    (option?.label ?? "").includes(input)
                  }
                  filterSort={(optionA, optionB) =>
                    (optionA?.label ?? "")
                      .toLowerCase()
                      .localeCompare((optionB?.label ?? "").toLowerCase())
                  }
                  options={floors}
                />
                <ErrorValidate justify="start" error={error} />
              </div>
            )}
          />

          <Controller
            name="description"
            control={control}
            // rules={_.get(VALIDATE_RULES, ["required"])}
            render={({ field, fieldState: { error } }) => (
              <div>
                <Text
                  color={COLOR_DARK}
                  fontSize="14px"
                  style={{ marginBottom: 4, marginLeft: 4 }}
                >
                  Description
                </Text>
                <StyledInput
                  label="description"
                  {...field}
                  size="large"
                  placeholder="Description"
                />
                <ErrorValidate justify="start" error={error} />
              </div>
            )}
          />

          <Controller
            name="player_id"
            control={control}
            // rules={_.get(VALIDATE_RULES, ["required"])}
            render={({ field, fieldState: { error } }) => (
              <div>
                <Text
                  color={COLOR_DARK}
                  fontSize="14px"
                  style={{ marginBottom: 4, marginLeft: 4 }}
                >
                  Player ID
                </Text>
                <StyledInput
                  label="player_id"
                  {...field}
                  size="large"
                  placeholder="Player ID"
                />
                <ErrorValidate justify="start" error={error} />
              </div>
            )}
          />
        </div>

        <ButtonContainer>
          <Button
            type="submit"
            color={COLOR_GREEN}
            fontColor={COLOR_WHITE}
            fontSize="16px"
            padding="5px 20px"
          >
            Save
          </Button>
        </ButtonContainer>
      </InnerContainer>
    </FormContainer>
  );
};
